import { IFederalStateLogin } from '../Interfaces/IFederalStateLogin';

/**
 * Auswahl der Grundbuch-Zugaenge fuer den Abruf.
 *
 * ``/landregister/access`` liefert ``isFirstStage`` unveraendert aus der DB
 * (tinyint), also ``0``/``1`` statt ``false``/``true`` — die Antwort wird im
 * Frontend nicht durch ``federalStateLoginSchema`` geparst. Deshalb wird hier
 * auf Wahrheitswert geprueft und nicht strikt mit ``false`` verglichen.
 */
export const isPersonalAccess = (access: IFederalStateLogin) =>
  !access.isFirstStage;

/** Persoenliche Zugaenge des Bundeslands (Erstanmeldung bleibt aussen vor). */
export const selectableAccesses = (
  accesses: IFederalStateLogin[] | undefined,
  idFederalState: number | null
): IFederalStateLogin[] => {
  if (!idFederalState) return [];
  return (accesses ?? []).filter(
    a => isPersonalAccess(a) && a.idFederalState === idFederalState
  );
};

/** Vorbelegung: nur wenn die Auswahl eindeutig ist. */
export const preselectedAccess = (
  accesses: IFederalStateLogin[] | undefined,
  idFederalState: number | null
): number | null => {
  const matching = selectableAccesses(accesses, idFederalState);
  return matching.length === 1 ? matching[0].idFederalStateLogin : null;
};
